/* TRIMSOUL - product page (reskinned).
   Gallery dots + swipe, options <-> inline size panel swap,
   INFORMATION inline toggle, size guide sheet, AJAX add to cart. */
(function () {
  'use strict';

  var TS = window.TRIMSOUL;
  if (!TS) {
    return;
  }

  /* global.js defines the helpers; it loads first, but never assume it here */
  if (typeof TS.qs !== 'function') {
    return;
  }

  function start() {
    var section = TS.qs('[data-pdp]');
    if (!section) {
      return;
    }

    initGallery(section);
    initPanel(section);
  }

  /* ---------- gallery: swipe + dot buttons ---------- */
  function initGallery(section) {
    var track = TS.qs('[data-pdp-track]', section);
    var dots = TS.qsa('[data-pdp-dot]', section);
    var status = TS.qs('[data-pdp-gallery-status]', section);

    if (!track || dots.length < 2) {
      return;
    }

    function setActive(index) {
      dots.forEach(function (dot, position) {
        var on = position === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (status) {
        status.textContent = 'IMAGE ' + (index + 1) + ' OF ' + dots.length;
      }
    }

    function current() {
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width);
      if (index < 0) index = 0;
      if (index > dots.length - 1) index = dots.length - 1;
      return index;
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setActive(current());
          ticking = false;
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot, position) {
      dot.addEventListener('click', function () {
        var step = track.clientWidth;
        track.scrollTo({ left: step * position, behavior: TS.reducedMotion() ? 'auto' : 'smooth' });
        setActive(position);
      });
    });

    track.setAttribute('tabindex', '0');
    track.setAttribute('role', 'group');
    track.setAttribute('aria-label', 'PRODUCT IMAGES, USE LEFT AND RIGHT ARROW KEYS');
    track.addEventListener('keydown', function (event) {
      var step = track.clientWidth;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        track.scrollTo({ left: step * Math.min(current() + 1, dots.length - 1), behavior: TS.reducedMotion() ? 'auto' : 'smooth' });
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        track.scrollTo({ left: step * Math.max(current() - 1, 0), behavior: TS.reducedMotion() ? 'auto' : 'smooth' });
      }
    });
  }

  /* ---------- options <-> size panel + information + guide ---------- */
  function initPanel(section) {
    var panel = TS.qs('[data-pdp-panel]', section);
    var options = TS.qs('[data-pdp-options]', section);
    var opener = TS.qs('[data-pdp-open]', section);
    if (!panel || !opener) {
      return;
    }

    var closer = TS.qs('[data-pdp-close]', section);
    var selectLabel = TS.qs('[data-pdp-select-label]', section);
    var priceNode = TS.qs('[data-panel-price]', section);
    var compareNode = TS.qs('[data-panel-compare]', section);
    var infoButton = TS.qs('[data-info-open]', section);
    var information = TS.qs('[data-pdp-information]', section);
    var guideButton = TS.qs('[data-sizeguide-open]', section);
    var guideDialog = TS.qs('[data-sizeguide]', section);
    var sizeButtons = TS.qsa('[data-pdp-size]', section);
    var lastFocus = null;
    var busy = false;

    function openPanel() {
      lastFocus = document.activeElement;
      if (options) options.hidden = true;
      panel.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      var firstSize = TS.qs('.size-row [data-pdp-size]:not([disabled])', panel);
      if (firstSize) firstSize.focus();
    }

    function closePanel() {
      panel.hidden = true;
      if (options) options.hidden = false;
      opener.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    opener.addEventListener('click', openPanel);
    if (closer) closer.addEventListener('click', closePanel);

    if (infoButton && information) {
      infoButton.addEventListener('click', function () {
        var show = information.hidden;
        information.hidden = !show;
        infoButton.setAttribute('aria-expanded', show ? 'true' : 'false');
      });
    }

    if (guideButton && guideDialog) {
      guideButton.addEventListener('click', function () {
        TS.openDialog(guideDialog);
      });
    }

    function lockSizes(locked) {
      sizeButtons.forEach(function (button) {
        if (locked) {
          button.classList.add('is-busy');
          if (!button.disabled) {
            button.setAttribute('data-was-enabled', 'true');
            button.disabled = true;
          }
        } else {
          button.classList.remove('is-busy');
          if (button.getAttribute('data-was-enabled') === 'true') {
            button.removeAttribute('data-was-enabled');
            button.disabled = false;
          }
        }
      });
      busy = locked;
    }

    function restoreLabel(button) {
      var label = TS.qs('[data-size-text]', button);
      if (label && button.hasAttribute('data-original-label')) {
        label.textContent = button.getAttribute('data-original-label');
        button.removeAttribute('data-original-label');
      }
    }

    function setSelectLabel(text) {
      if (selectLabel) selectLabel.textContent = text;
    }

    function setPrice(button) {
      var price = button.getAttribute('data-variant-price');
      var compare = button.getAttribute('data-variant-compare');

      if (priceNode && price) {
        priceNode.textContent = TS.formatMoney(Number(price) * 100);
      }
      if (compareNode) {
        if (compare && Number(compare) > Number(price)) {
          compareNode.hidden = false;
          compareNode.textContent = TS.formatMoney(Number(compare) * 100);
        } else {
          compareNode.hidden = true;
        }
      }
    }

    function add(variantId, button) {
      if (busy) {
        return;
      }

      var label = TS.qs('[data-size-text]', button);
      if (label) {
        button.setAttribute('data-original-label', label.textContent);
        label.textContent = TS.strings.adding || 'ADDING';
      }
      setSelectLabel(TS.strings.adding || 'ADDING');
      if (closer) closer.disabled = true;

      lockSizes(true);

      function finish() {
        window.setTimeout(function () {
          lockSizes(false);
          restoreLabel(button);
          setSelectLabel('SELECT SIZE');
          if (closer) closer.disabled = false;
          closePanel();
        }, 1000);
      }

      function fail() {
        if (label) {
          label.textContent = TS.strings.error || 'ERROR';
        }
        setSelectLabel(TS.strings.error || 'ERROR');
        window.setTimeout(function () {
          lockSizes(false);
          restoreLabel(button);
          setSelectLabel('SELECT SIZE');
          if (closer) closer.disabled = false;
        }, 1500);
      }

      if (!window.fetch) {
        var form = document.createElement('form');
        form.method = 'post';
        form.action = TS.routes.cart_add;

        var idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = String(variantId);
        form.appendChild(idInput);

        var quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.value = '1';
        form.appendChild(quantityInput);

        document.body.appendChild(form);
        form.submit();
        return;
      }

      window
        .fetch(TS.routes.cart_add + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('add to cart failed');
          }
          return response.json();
        })
        .then(function () {
          TS.addToBagCount(1);
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'trimsoul' } }));
          finish();
        })
        .catch(fail);
    }

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) {
          return;
        }
        setPrice(button);
        var variantId = button.getAttribute('data-variant-id');
        if (variantId) {
          add(variantId, button);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
